import {
  VALID_CONDITIONS,
  VEHICLE_STATES,
  type FeedMapping,
} from '@/types/feedMapping'

/**
 * Builds an explicit matrix so every row in the editor displays the selected
 * feed. The backend also supports a catch-all-only matrix, but explicit rows
 * make the onboarding default visible and editable.
 */
export function buildAllStateFeedMapping(feed: string): FeedMapping {
  const mapping: FeedMapping = {}

  for (const condition of VALID_CONDITIONS) {
    mapping[condition] = {}
    for (const state of VEHICLE_STATES) {
      mapping[condition][state] = feed
    }
  }

  return mapping
}
